/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InlineEditNumberDirective {
    public restrict = 'E';
    public scope;
    public template;

    public currentValue;

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            value: '=',
            saveFunc: '&?',
            validateFunc: '&?',
            label: '@?',
            canEdit: '=?',
            min: '=?',
            max: '=?'
        };

        this.template = `
            <md-input-container class="d-flex">
                <label ng-if="label">{{label}}</label>
                <input ng-model="value" ng-click="edit()" ng-blur="doneEdit()" ng-keydown="isNumberKey($event);" ng-disabled="canEdit == false" aria-label="{{label}}">
            </md-input-container>
        `;
    }


    public link($scope: any, $element: any, attrs: any): any {
        var inputElement: any = $($element).find(':input')[0];
        // $element.addClass('inline-edit-number');
        // $scope.editing = false;

        if ($scope.value === "---") {
            $scope.value = undefined;
        }

        $scope.isNumberKey = function (evt: any): any {
            var key: any = evt.keyCode;
            key = String.fromCharCode(key);
            var regex: any = /[0-9]|\./;
            // prevent special characters as well as underscores
            if (((evt.keyCode >= 49 && evt.keyCode <= 56) || evt.keyCode === 189) && (evt.shiftKey === true)) {
                evt.returnValue = false;
                evt.preventDefault();
            }
            if (
                // allow only numbers
                evt.keyCode === 8 || evt.keyCode === 46 || evt.keyCode === 37 || evt.keyCode === 39 ||
                // allow spaces and dashes (main + keypad)
                evt.keyCode === 32 || evt.keyCode === 189 || evt.keyCode == 109 ||
                // allow decimal (main + keyoad)
                evt.keyCode === 190 || evt.keyCode === 110 ||
                // allow plus sign
                (evt.keyCode === 187 && evt.shiftKey === true) ||
                // allow number pad keys
                evt.keyCode >= 96 && evt.keyCode <= 105 || evt.keyCode === 107 ||
                // enable copy and pasting inside the number fields
                ((evt.keyCode === 65 || evt.keyCode === 86 || evt.keyCode === 67) && (evt.ctrlKey === true || evt.metaKey === true))) {
                    evt.returnValue = true;
            } else {
                if (!regex.test(key)) {
                    evt.returnValue = false;
                    if (evt.preventDefault) {
                        // prevent any other input
                        evt.preventDefault();
                    }
                }
            }
        };

        $scope.edit = function (): any {
            // $scope.editing = true;
            this.currentValue = $scope.value;
            // $element.addClass('active');
            // $element.addClass('');
            inputElement.focus();
        };

        $scope.doneEdit = function (): any {
            // Perform validation
            if (typeof $scope.min !== 'undefined') {
                if ($scope.value < $scope.min) {
                    $scope.value = this.currentValue;
                    return;
                }
            }

            if (typeof $scope.max !== 'undefined') {
                if ($scope.value > $scope.max) {
                    return;
                }
            }

            // $scope.editing = false;
            var newValue: any = $scope.value;

            // $element.removeClass('active');
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };

            if($scope.validateFunc !== undefined){
                if (!$scope.validateFunc({args: saveObj})) {
                    $scope.value = this.currentValue;
                    return;
                }
            }
            if($scope.saveFunc !== undefined){
                $scope.saveFunc({args: saveObj});
            }
        };

        $scope.undo = function (): any {
            // $element.removeClass('active');
            $scope.value = this.currentValue;
        };
    }

    public static DirectiveFn($timeout: any): InlineEditNumberDirective {
        return new InlineEditNumberDirective($timeout);
    }
}

InlineEditNumberDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditNumber', InlineEditNumberDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_number.directive.ts